import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import { t } from 'i18next';
import { useState } from 'react';

import { openStorePage } from './openStorePage';

const DISMISSED_KEY = 'OnTheBuckUpdateDismissed';

function readDismissedVersion(): string | null {
	try {
		return localStorage.getItem(DISMISSED_KEY);
	} catch {
		return null;
	}
}

function writeDismissedVersion(version: string): void {
	try {
		localStorage.setItem(DISMISSED_KEY, version);
	} catch {
		// Losing the dismissal only means the prompt comes back once.
	}
}

/** Offered once per release: dismissing it, or opening the store, silences it until a newer one. */
export function UpdateAvailableModal({ latestVersion, storeUrl }: { latestVersion: string; storeUrl: string }) {
	const [dismissed, setDismissed] = useState(() => readDismissedVersion() === latestVersion);

	if (dismissed) {
		return null;
	}

	const dismiss = () => {
		writeDismissedVersion(latestVersion);
		setDismissed(true);
	};

	const update = () => {
		dismiss();
		openStorePage(storeUrl);
	};

	return (
		<Modal opened onClose={dismiss} title={t('appUpdate.availableTitle')} centered>
			<Stack gap="md">
				<Text size="sm">{t('appUpdate.availableBody')}</Text>
				<Group justify="flex-end" gap="sm">
					<Button variant="default" onClick={dismiss}>
						{t('appUpdate.later')}
					</Button>
					<Button onClick={update}>{t('appUpdate.update')}</Button>
				</Group>
			</Stack>
		</Modal>
	);
}
